Vue.component("tabContent", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="tabContent-entrance">
            <div class="tabContent__wrapper content__wrapper" v-if="contentReady" >

                <div class="content__left">
                    <div class="button__back button" @click="close">
                        <span>Tilbage</span>
                    </div>

                    <h3>Tavlemøder</h3>
                    <h1 v-html="title"></h1>

                    <nav class="tabContent__left_navigation" v-if="tabs.length > 1">
                        <div v-for="(nav, i) in tabs" :key="nav.title" v-html="nav.title" @click="selectTab(i)" :class="getTabNavigationActiveClass(i)"></div>
                    </nav>
                    

                    <div class="content__left_text" v-if="selectedTab.text">
                        <div v-html="selectedTab.text"></div>
                        <TkReader :audio="selectedTab.textToSpeech"></TkReader>
                    </div>
                    <div class="tabContent__left_models" v-if="selectedTab.modeller">
                        <ul>
                            <li v-for="(model, i) in selectedTab.modeller" @click="selectModel(i)" :class="{'tabContent__left_models--selected': i === selectedModelIndex}">
                                <h4 v-html="model.title"></h4>
                                <div>
                                    <img :src="imgDirectory + model.image.src">
                                </div>
                            </li>
                        </ul>
                    </div> 

                </div>


                <div class="content__right">
                    <TkSlider v-if="selectedTab.hasOwnProperty('carousel')" :elements="selectedTab.carousel" startindex="0">
                        <template v-slot:default="data">
                            <img :src="imgDirectory + data.cfg.image.src">
                            <div class="content__right__title">
                                <h2 v-html="data.cfg.title"></h2>
                                <h4 v-html="data.cfg.subtitle"></h4>
                            </div>
                        </template> 
                    </TkSlider>

                    <div class="content__right__modelwrapper" v-if="selectedModel !== false">
                        <img :src="imgDirectory + selectedModel[0].image.src">
                        
                        <div class="content__right__title">
                            <h2 v-html="selectedModel[0].title"></h2>
                            <h4 v-html="selectedModel[0].subtitle"></h4>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    `,
    data() {
        return {
            title: '',
            tabs: [],


            activeTab: 0,
            contentReady: false,
            imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
            selectedModelIndex: 0
        }
    },
    methods: {
        selectTab(i) {
            this.activeTab = i;
        },
        isActiveTab(i) {
            return this.activeTab === i
        },
        getTabNavigationActiveClass(i) {
            return {
                'tabContent__left_navigation--active': this.isActiveTab(i)
            }
        },
        selectModel(i) {
            this.selectedModelIndex = i;
        }
    },
    mounted() {
        this.contentReady = true;
    },
    computed: {
        selectedTab() {
            return this.tabs[this.activeTab]
        },
        selectedModel() {
            if (this.selectedTab.modeller) {
                return this.selectedTab.modeller.filter((tab, i) => {
                    if (i === this.selectedModelIndex) {
                        return tab;
                    }
                });
            } else {
                return false
            }
        },
    }
})

touchKit.ComponentManager.register("tabContent", {
    singleton: true
});